export default __webpack_public_path__ + "static/media/qr-code-4.21ff78da.svg";